/**
 * Identity of the runner. Swap this for the real LAN attendee's nick.
 */
export const PLAYER_NAME = 'Koodinimi "Kimmo"';

/** Shown on the READY screen under the title. */
export const PLAYER_TAGLINE = 'Ohjaa "Kimmo" omalle koneelleen.';

/**
 * Genitive form, for the HUD's speedometer: `"Kimmon" nopeus  24.8 km/h`.
 *
 * Separate from `PLAYER_NAME` because Finnish will not let you build it by
 * concatenation - and because the speedometer wants the nickname on its own,
 * without the "Koodinimi" the READY screen introduces him by.
 */
export const PLAYER_POSSESSIVE = '"Kimmon"';

/**
 * The koodinimi on its own, for the lappu taped over his bed.
 *
 * Its own constant for the same reason `PLAYER_POSSESSIVE` is: a sign is a name
 * on a wall, not an introduction, and `Koodinimi "Kimmo"` written over a pillow
 * would read as the label on a hospital chart. The quotes stay - the venue
 * writes every koodinimi that way, and the lappu over the other bed says
 * `"Juppe"`. See `ROOMMATE_NAME` in `src/config/level.ts`.
 */
export const PLAYER_ALIAS = '"Kimmo"';
